import User from "./_user";
import Value from "./_value";
import Country from "./_country";
import Century from "./_century";
import Occasion from "./_occasion";
import Document from "./_document";
import Tag from "./_tag";
import Type from "./_type";
import Artifact from "./_artifact";
import Administrator from "./_administrator";
import Content from "./_content";
import Plan from "./_plan";
import Subscribe from "./_subscribe";
import SubscribeGift from "./_subscribeGift";
import PlanDescription from "./_planDescription";
import PlanPermission from "./_planPermission";
import Transaction from "./_transaction";
import ConciergeService from "./_conciergeService";
import BlogCategory from "./_blogCategory";
import BlogPost from "./_blogPost";
import AdminRole from "./_role";
import AdminPermission from "./_permission";
import PromoCode from "./_promo_code";
import PartnerPromoCode from "./_partner_promo_code";
import Unit from "./_unit";
import Valuation from "./_valuation";
import ViolationReports from './_violationReports';

import sharing_list from "./_sharing_list";
import circle_list from "./_circle_list";
import homepage from "./_homepage";
import artiPro from "./_artiPro";
import forMom from "./_forMom";

import company from "./company/_company";
import companyRequest from "./company/_companyRequest";
import forProfessionals from "./company/_forProfessionals";
import _qr_code from "./_qr_code";
import _komen from "./_komen";
import _artiProMembership from "./_artiProMembership";


export default {
    user: User,
    administrator: Administrator,
    adminRole: AdminRole,
    adminPermission: AdminPermission,

    content: Content,

    concierge_service: ConciergeService,

    blog_category: BlogCategory,
    blog_post: BlogPost,

    subscription: Subscribe,
    subscription_gift: SubscribeGift,
    transaction: Transaction,
    plan: Plan,
    plan_description: PlanDescription,
    plan_permission: PlanPermission,

    unit: Unit,
    valuation: Valuation,
    violationReports: ViolationReports,
    value: Value,
    country: Country,
    century: Century,
    occasion: Occasion,
    document: Document,
    tag: Tag,
    type: Type,
    artifact: Artifact,

    promo_code: PromoCode,
    partner_promo_code: PartnerPromoCode,

    homepage: homepage,
    forMom: forMom,
    artiPro: artiPro,

    sharing_list: sharing_list,
    circle_list: circle_list,

    company: company,
    companyRequest: companyRequest,
    forProfessionals: forProfessionals,

    qrCode: _qr_code,
    komen: _komen,

    artiProMembership: _artiProMembership,
}
